// extracted by mini-css-extract-plugin
export default {"oldFiles":"dataRoom_oldFiles__cGSYE","oldFiles_item":"dataRoom_oldFiles_item__03GQv"};